<div class="container">
  <h2>{{"DIARY.TITLE" | translate}}</h2>

  <div class="week-thropies-diary" (click)="guiService.goTo('main/trophies')" *ngIf="thropiesLoaded && this.guiService.programs.length > 0">
    <p>{{"DIARY.THROPIES" | translate}}</p>
    <img src="../../assets/img/trophy_pink.svg" alt="">
  </div>
  <div class="double-box-info" *ngIf="thropiesLoaded && this.guiService.programs.length > 0">
    <div class="box-try-1">
      <span>{{workoutCompletedInWeek()}}/{{countWeeklyWorkout()}}</span>
      <p>{{"DIARY.WORKOUT-OF-WEEK" | translate}}</p>
    </div>
    <div style="width: 20px;"></div>
    <div class="box-try-2">
      <span>{{completedThropies}}</span>
      <p>{{"DIARY.COMPLETED-THROPIES" | translate}}</p>
    </div>
  </div>
    <div class="right-side" *ngIf="thropiesLoaded && this.guiService.programs.length > 0">
      <div class="box box-1" (click)="guiService.goTo('main/workout-history')">
        <mat-icon svgIcon="mat:fitness_center"></mat-icon>
        <p>{{"DIARY.WORKOUT-HISTORY" | translate}}</p>
      </div>
      <div class="box box-2" (click)="guiService.goTo('main/exercise-tracker')">
        <mat-icon svgIcon="mat:bar_chart"></mat-icon>
        <p>{{"DIARY.EXERCISE-TRACKER" | translate}}</p>
      </div>
      <div class="box box-3" (click)="guiService.goTo('main/favorite-workouts')">
        <mat-icon svgIcon="mat:favorite"></mat-icon>
        <p>{{"DIARY.FAVORITES" | translate}}</p>
      </div>
    </div>
    <div class="week-thropies-diary skeleton" *ngIf="!thropiesLoaded || this.guiService.programs.length < 1"></div>
    <div class="double-box-info" *ngIf="!thropiesLoaded || this.guiService.programs.length < 1">
      <div class="box-try-1 skeleton"></div>
      <div style="width: 20px;"></div>
      <div class="box-try-2 skeleton"></div>
    </div>
    <div class="right-side" *ngIf="!thropiesLoaded || this.guiService.programs.length < 1">
      <div class="box box-1 skeleton"></div>
      <div class="box box-2 skeleton"></div>
      <div class="box box-3 skeleton"></div>
    </div>
</div>
